import { render, staticRenderFns } from "./CardSectionPropertiesWithImage.vue?vue&type=template&id=188efd46&"
import script from "./CardSectionPropertiesWithImage.vue?vue&type=script&lang=js&"
export * from "./CardSectionPropertiesWithImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports